import i18n from "i18next";
import { LOCALE_REGISTRY } from "./registry.js";
import { SUPPORTED_LANGUAGE_CODES } from "./languages.js";
// Build i18next resources from the locale registry (single source of truth).
const resources = Object.fromEntries(Object.entries(LOCALE_REGISTRY).map(([code, entry]) => [
    code,
    { translation: entry.messages },
]));
// Safe as a plain boolean because init is synchronous (initImmediate: false).
let initialized = false;
/**
 * Initialize the shared i18next singleton with the bundled translations.
 * Call once at app startup.
 *
 * `plugins` lets each layer add its own framework integration WITHOUT pulling
 * React into @dosia/shared (架构红线 #2 依赖方向): the renderer passes
 * `[LanguageDetector, initReactI18next]`, node-side callers pass nothing.
 *
 * fallbackLng is "zh-Hans" — the base locale (现有中文即真相源). Keys are flat
 * and dot-namespaced ("settings.general.theme.label"), so `keySeparator` is
 * turned OFF: a lookup uses the whole string as the key rather than descending
 * a nested object.
 */
export function setupI18n(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugins = []) {
    if (initialized)
        return i18n;
    let instance = i18n;
    for (const plugin of plugins) {
        instance = instance.use(plugin);
    }
    instance.init({
        resources,
        fallbackLng: "zh-Hans",
        supportedLngs: [...SUPPORTED_LANGUAGE_CODES],
        keySeparator: false,
        interpolation: { escapeValue: false },
        initImmediate: false, // synchronous init — resources are bundled inline
        detection: {
            // "navigator" intentionally excluded: 默认落 fallbackLng (zh-Hans),
            // 只有用户显式切换过语言（写入 localStorage）才尊重那次选择。
            order: ["localStorage"],
            caches: ["localStorage"],
            lookupLocalStorage: "i18nextLng",
        },
    });
    initialized = true;
    return i18n;
}
export { i18n };
//# sourceMappingURL=setupI18n.js.map